import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CorrespondenceIssuedCategoryActions from './issued-category.actions';
import { CorrespondenceIssuedCategoryService } from '../../services/issue-category.service';

@Injectable()
export class CorrespondenceIssuedCategoryEffects {
  loadCorrespondenceIssuedCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CorrespondenceIssuedCategoryActions.loadCorrespondenceIssuedCategory
      ),
      exhaustMap((_) =>
        this.correspondenceIssuedCategoryService
          .getCorrespondenceIssuedCategory()
          .pipe(
            map((data) =>
              CorrespondenceIssuedCategoryActions.loadCorrespondenceIssuedCategorySuccess(
                { correspondenceIssuedCategory: data }
              )
            ),
            catchError((error) =>
              of(
                CorrespondenceIssuedCategoryActions.loadCorrespondenceIssuedCategoryFailure(
                  { error }
                )
              )
            )
          )
      )
    )
  );

  addCorrespondenceIssuedCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CorrespondenceIssuedCategoryActions.addCorrespondenceIssuedCategory
      ),
      concatMap(({ newCorrespondenceIssuedCategory }) =>
        this.correspondenceIssuedCategoryService
          .createCorrespondenceIssuedCategory(newCorrespondenceIssuedCategory)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return CorrespondenceIssuedCategoryActions.addCorrespondenceIssuedCategorySuccess(
                {
                  newCorrespondenceIssuedCategory: data,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceIssuedCategoryActions.addCorrespondenceIssuedCategoryFailure(
                  { error: error.error.message }
                )
              )
            )
          )
      )
    )
  );

  updateCorrespondenceIssuedCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CorrespondenceIssuedCategoryActions.updateCorrespondenceIssuedCategory
      ),
      map((action) => action.updateCorrespondenceIssuedCategory),
      concatMap((updateCorrespondenceIssuedCategory) =>
        this.correspondenceIssuedCategoryService
          .updateCorrespondenceIssuedCategory(
            updateCorrespondenceIssuedCategory
          )
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return CorrespondenceIssuedCategoryActions.updateCorrespondenceIssuedCategorySuccess(
                {
                  updateCorrespondenceIssuedCategory: updateCorrespondenceIssuedCategory,
                }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceIssuedCategoryActions.updateCorrespondenceIssuedCategoryFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  removeCorrespondenceIssuedCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        CorrespondenceIssuedCategoryActions.removeCorrespondenceIssuedCategory
      ),
      map((action) => action.ids),
      concatMap((ids) =>
        this.correspondenceIssuedCategoryService
          .deleteCorrespondenceIssuedCategory(ids)
          .pipe(
            map(() => {
              this.notification.success('Deleted Successfully');
              return CorrespondenceIssuedCategoryActions.removeCorrespondenceIssuedCategorySuccess(
                { ids }
              );
            }),
            catchError((error) =>
              of(
                CorrespondenceIssuedCategoryActions.updateCorrespondenceIssuedCategoryFailure(
                  { error: error.message }
                )
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private correspondenceIssuedCategoryService: CorrespondenceIssuedCategoryService,
    private notification: NotificationService
  ) {}
}
